import { ContentWrapper727 } from "../../components/contentWrappers/ContentWrapper727";
import { InfoSection } from "./components/main/InfoSection";
import { Main } from "./components/main/Main";
import { OptionPositions } from "./components/rewards/table/OptionPositions";
import { RightSection } from "./components/rightSection/RightSection";

export const GovernancePage = () => {
  return (
    <div className="flex flex-col md:flex-row">
      <div className="flex flex-col flex-grow md:px-8 pb-8 ">
        <ContentWrapper727>
          <div className="mb-4">
            <Main />
          </div>
          <div className="mb-4">{/* <RewardsComponent /> */}</div>
          <div className="mb-4">
            <OptionPositions />
          </div>
          <div>
            <InfoSection />
          </div>
          <div className="block mt-4 md:hidden">
            <RightSection />
          </div>
        </ContentWrapper727>
      </div>

      {/* Right Section for Larger Screens */}
      <div className="hidden md:block w-[348px] h-screen md:right-8 md:top-16">
        <RightSection />
      </div>
    </div>
  );
};
